import { GAEvent, GAEventNames } from "game/analytics/events";
import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { useSelector } from "react-redux";
import { UIRootState } from "ui/store/reducers";
import { Popups, StoriesCongratulationsPopupData } from "ui/types/popups";

export const StoriesCongratulationsPopup = () => {
    const data = useSelector((state: UIRootState) => state.popups?.[Popups.STORIES_CONGRATULATIONS_POPUP]?.data) as StoriesCongratulationsPopupData;
    
    const handleWatchVideoBtnClick = () => {
        GAEvent(GAEventNames.STORIES_CONGRATULATIONS_BANNER_PLAY_VIDEO, {
            story_name: data?.storyId,
        });

        document.dispatchEvent(new CustomEvent("ui-button-click", { detail: { buttonKey: 'watch-story-video-btn', data: {
            storyNumber: 'video-story',
            storyId: data?.storyId,
        } } }));
        GameUI.closePopup(Popups.STORIES_CONGRATULATIONS_POPUP);
    }

    return (
        <div id="stories_congratulations" role="tooltip" className="modals_area active">
            <div id="closing-ignore-el" className="wrapper">
                <div className="text_content">
                    <span className="modals_area-title">{translate("stories_congratulations_title")}</span>
                    <img className="modals_area_img" src={data?.imageSrc} alt="Congratulations"/>
                    <p className="modals_area-text">{translate("stories_congratulations_text")}</p>
                    <div className="feedback_btn-wrap">
                        <button id="closing-ignore-el" type="button" className="modals_area-btn watch-video-button" onClick={handleWatchVideoBtnClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <g filter="url(#filter0_d_384_1506)">
                                    <path d="M3.75 4.39754C3.75 3.46832 4.72789 2.86395 5.55902 3.27951L17.7639 9.38197C18.6852 9.84262 18.6852 11.1574 17.7639 11.618L5.55902 17.7205C4.72789 18.1361 3.75 17.5317 3.75 16.6025V4.39754Z" fill="white"></path>
                                </g>
                                <defs>
                                    <filter id="filter0_d_384_1506" x="3.75" y="3.146" width="14.7051" height="15.3728" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                                        <feOffset dy="0.664795"></feOffset>
                                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_384_1506"></feBlend>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_384_1506" result="shape"></feBlend>
                                    </filter>
                                </defs>
                            </svg>
                            {translate("stories_congratulations_button")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}